import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const apiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || "Invalid field").join(" ");
  return error?.message || "Something went wrong. Please try again.";
};

export const track = (event, page, metadata = {}) => api.post("/analytics/event", { event, page, metadata }).catch(() => null);
export const submitContact = (payload) => api.post("/contact", payload).then((response) => response.data);
export const submitSango = (payload) => api.post("/inquiries/sango", payload).then((response) => response.data);
export const submitBookingRequest = (payload) => api.post("/inquiries/booking-request", payload).then((response) => response.data);
export const submitIfa = (payload) => api.post("/bookings/ifa", payload).then((response) => response.data);
export const submitFitness = (payload) => api.post("/bookings/fitness", payload).then((response) => response.data);
export const submitBenin = (payload) => api.post("/bookings/benin", payload).then((response) => response.data);
export const login = (payload) => api.post("/auth/login", payload).then((response) => response.data);
export const logout = () => api.post("/auth/logout").then((response) => response.data);
export const currentUser = () => api.get("/auth/me").then((response) => response.data);
export const getAdminOverview = () => api.get("/admin/overview").then((response) => response.data);
export const getAdminBookings = (params = {}) => api.get("/admin/bookings", { params }).then((response) => response.data);
export const getAdminInquiries = () => api.get("/admin/inquiries").then((response) => response.data);
export const getAdminAnalytics = () => api.get("/admin/analytics").then((response) => response.data);
export const updateBookingStatus = (id, status) => api.post(`/admin/bookings/${id}/status`, { status }).then((response) => response.data);
export const clientAuthSession = (sessionId) => api.post("/client-auth/session", { session_id: sessionId }).then((response) => response.data);
export const clientAuthMe = () => api.get("/client-auth/me").then((response) => response.data);
export const clientAuthLogout = () => api.post("/client-auth/logout").then((response) => response.data);
export const clientBookings = () => api.get("/client/bookings").then((response) => response.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((response) => response.data);
export const approveInquiry = (id, payload) => api.post(`/admin/inquiries/${id}/approve`, payload).then((response) => response.data);

export default api;

